var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g2, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationTruckFacility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 200,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CACCCF",
    fillOpacity: 0.2,
    fillRule: "evenodd",
    d: "M298.162 88.261c14.852 39.726-65.878 76.202-102.118 79.31-36.137 3.264-103.266 7.842-149.092-43.036-45.695-51.066-13.308-143 89.864-104.313 103.255 38.795 146.585 28.442 161.346 68.039Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 274,
    height: 160,
    x: 26,
    y: 10,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M298.162 88.261c14.852 39.726-65.878 76.202-102.118 79.31-36.137 3.264-103.266 7.842-149.092-43.036-45.695-51.066-13.308-143 89.864-104.313 103.255 38.795 146.585 28.442 161.346 68.039Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5C6A76",
    d: "M275.255 122.051s-65.901 19.665-125 23.602c-59.098 3.938-146.588 2.662-146.588 2.662l-20.897-18.659s216.104-.985 259.076-7.605c.014.015 33.409 0 33.409 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8F9FB",
    d: "M230.693 121.891h107.921V65.456H230.693v56.435Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EDF2",
    d: "M230.693 119.512h107.921v-.192H230.693v.192ZM230.693 116.542h107.921v-.193H230.693v.193ZM230.693 113.571h107.921v-.192H230.693v.192ZM230.693 110.602h107.921v-.193H230.693v.193ZM230.693 106.64h107.921v-.191H230.693v.191ZM230.693 103.67h107.921v-.192H230.693v.192ZM230.693 100.7h107.921v-.192H230.693v.192ZM230.693 97.73h107.921v-.192H230.693v.192ZM230.693 94.76h107.921v-.193H230.693v.193ZM230.693 91.79h107.921v-.194H230.693v.194ZM230.693 88.819h107.921v-.192H230.693v.192ZM230.693 85.849h107.921v-.192H230.693v.192ZM230.693 82.878h107.921v-.192H230.693v.192ZM230.693 79.908h107.921v-.192H230.693v.192ZM230.693 76.938h107.921v-.192H230.693v.192ZM230.693 73.967h107.921v-.192H230.693v.192ZM230.693 70.998h107.921v-.194H230.693v.194ZM230.693 68.027h107.921v-.192H230.693v.192ZM230.693 65.456h107.921v-5.941H230.693v5.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1CED9",
    d: "M230.693 67.436h107.921v-1.98H230.693v1.98ZM284.159 121.891h37.623V81.297h-37.623v40.594Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8F9FB",
    d: "M286.139 121.891h33.663V84.267h-33.663v37.624Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EDF2",
    d: "M287.68 89.458h31.531c.239 0 .437-.288.437-.65v-1.676c0-.36-.198-.654-.437-.654H287.68c-.245 0-.44.294-.44.654v1.675c0 .363.195.651.44.651Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E768A",
    d: "M287.68 94.602h14.394c.239 0 .437-.287.437-.65v-1.675c0-.36-.198-.653-.437-.653H287.68c-.245 0-.44.293-.44.653v1.675c0 .363.195.65.44.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EDF2",
    d: "M287.68 99.748h31.531c.239 0 .437-.288.437-.65v-1.676c0-.36-.198-.654-.437-.654H287.68c-.245 0-.44.294-.44.654v1.675c0 .363.195.65.44.65ZM287.68 104.892h31.531c.239 0 .437-.287.437-.65v-1.675c0-.36-.198-.654-.437-.654H287.68c-.245 0-.44.294-.44.654v1.675c0 .363.195.65.44.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EDF2",
    d: "M319.409 101.992a.91.91 0 0 1 .055.295v1.674c0 .36-.2.658-.443.658h-31.528a.403.403 0 0 1-.201-.076c.073.202.218.35.385.35h31.531c.245 0 .44-.295.44-.655v-1.674c0-.248-.099-.461-.239-.572ZM287.68 110.037h31.531c.239 0 .437-.287.437-.651v-1.674c0-.36-.198-.654-.437-.654H287.68c-.245 0-.44.294-.44.654v1.674c0 .364.195.651.44.651ZM287.68 115.182h31.531c.239 0 .437-.288.437-.651v-1.675c0-.359-.198-.654-.437-.654H287.68c-.245 0-.44.295-.44.654v1.675c0 .363.195.651.44.651ZM287.68 120.326h31.531c.239 0 .437-.287.437-.65v-1.675c0-.36-.198-.653-.437-.653H287.68c-.245 0-.44.293-.44.653v1.675c0 .363.195.65.44.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1CED9",
    d: "M239.867 121.81h36.945V81.322h-36.945v40.488Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E768A",
    d: "M241.605 121.811h33.468V84.614h-33.468v37.197Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8F9FB",
    d: "M241.605 89.735h33.468v-5.121h-33.468v5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EDF2",
    d: "M241.605 89.735h33.468v-.247h-33.468v.247ZM242.656 88.54h31.531c.238 0 .437-.287.437-.65v-1.674c0-.36-.199-.654-.437-.654h-31.531c-.245 0-.441.293-.441.654v1.674c0 .363.196.65.441.65Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4A55",
    fillRule: "evenodd",
    d: "M154.904 119.167h31.172l-.117-11.734h-31.172l.117 11.734Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E768A",
    fillRule: "evenodd",
    d: "M116.429 113.184c-3.155.159-5.651 5.597-5.574 12.144.076 6.548 2.697 11.727 5.852 11.568h5.722l-.662-14.467-5.338-9.245Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E768A",
    fillRule: "evenodd",
    d: "M128.734 124.751c-.077-6.546-2.697-11.726-5.853-11.567-3.155.159-5.651 5.597-5.574 12.143.076 6.549 2.696 11.728 5.852 11.569 3.156-.159 5.652-5.597 5.575-12.145ZM149.528 113.489c-3.155.159-5.651 5.596-5.575 12.143.077 6.548 2.698 11.728 5.853 11.569h5.722l-.663-14.467-5.337-9.245Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E768A",
    fillRule: "evenodd",
    d: "M161.832 125.055c-.076-6.546-2.697-11.726-5.852-11.566-3.155.159-5.651 5.596-5.574 12.142.076 6.549 2.696 11.729 5.851 11.57 3.156-.16 5.652-5.597 5.575-12.146Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0CA933",
    fillRule: "evenodd",
    d: "M157.815 96.539h31.323L181.7 56.596l-23.885-.032v39.975Z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#33CC60",
    fillRule: "evenodd",
    d: "M181.883 74.48V58.122c0-1.451-1.067-1.535-1.067-1.535h1.058s18.284.84 18.275 12.125c-.005 6.803-6.561 8.09-6.561 8.09l-11.705-2.324Z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0CA933",
    fillRule: "evenodd",
    d: "M181.883 65.939v8.352h17.554c-.486-5.532-.186-8.352-2.674-8.352h-14.88Z",
    clipRule: "evenodd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#0CA933",
    fillRule: "evenodd",
    d: "M158.18 108.121h31.323l-3.969-39.976H158.18v39.976Z",
    clipRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4A55",
    fillRule: "evenodd",
    d: "M163.072 111.174h25.124l2.151 5.204h-28.528l1.253-5.204Z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#33CC60",
    fillRule: "evenodd",
    d: "M190.724 108.121h-5.19V68.713h5.19v39.408Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 209,
    height: 91,
    x: 2,
    y: 48,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2.249 138.723h208.253V48H2.249v90.723Z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFF",
    fillRule: "evenodd",
    d: "M201.794 111.819h4.012v-5.043h-4.012v5.043Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E768A",
    fillRule: "evenodd",
    d: "M147.795 109.806h13.174l3.819 4.849h43.446l-8.722 12.684h-62.443v-12.684l10.726-4.849Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E768A",
    fillRule: "evenodd",
    d: "M172.309 125.041h-2.397l-.626-2.878v-7.508h3.023v10.386Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33CC60",
    fillRule: "evenodd",
    d: "M188.893 68.67v41.927l18.713 4.163 1.445-1.879c.001-.905.005-1.547.005-4.316 0-2.786-.115-6.06-.335-9.504l-.051-.774-2.13-17.473.361-2.36c-.507-5.33-2.372-8.48-3.886-8.854-4.409-1.09.703-.93-14.122-.93Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFF",
    fillRule: "evenodd",
    d: "m205.967 82.039.543 6.106c.314 3.547.661 7.434.826 9.294.06.693.232 1.163.568 1.301.336.139.817.32.817.32l-.051-.773-.488-5.464-1.069-11.989-.001-.01h-.822c-.25 0-.39.46-.323 1.215Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33CC60",
    fillRule: "evenodd",
    d: "M209.457 103.513c.499 0 .906.405.906.9v7.59c0 .494-.407.9-.906.9h-1.79a7.49 7.49 0 0 1-1.774-.259l-3.552-1.06c-.477-.142-.868-.664-.868-1.159v-6.012c0-.495.408-.9.906-.9h7.078Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0CA933",
    fillRule: "evenodd",
    d: "M188.783 75.933v-.78s18.681.234 18.616-.59c.272 2.017 1.09 4.564 1.351 7.306h-2.783l-.39-3.903-16.794-2.032Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33CC60",
    fillRule: "evenodd",
    d: "M206.151 112.876v-10.664c0-.793-.056-2.086-.123-2.876l-1.661-19.446c-.067-.789-.775-1.435-1.572-1.435h-12.294c-.797 0-1.449.648-1.449 1.44v31.924",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0CA933",
    strokeWidth: 1.391,
    d: "M206.151 112.876v-10.664c0-.793-.056-2.086-.123-2.876l-1.661-19.446c-.067-.789-.775-1.435-1.572-1.435h-12.294c-.797 0-1.449.648-1.449 1.44v31.924"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFF",
    fillRule: "evenodd",
    d: "M194.889 82.241v10.216c0 .791-.615 1.22-1.364.952l-1.734-.61c-.75-.27-1.364-1.134-1.364-1.926v-8.528c0-.79.656-1.454 1.452-1.475l1.563-.036a1.407 1.407 0 0 1 1.447 1.407ZM204.267 95.2c.058.739-.458 1.122-1.156.848l-4.207-1.656c-.427-.17-.807-.548-1.036-.994a1.838 1.838 0 0 1-.23-.854v-10.37c0-.745.615-1.35 1.359-1.35h2.729a1.5 1.5 0 0 1 1.469 1.346l.375 4.584.697 8.445Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0CA933",
    strokeWidth: 1.391,
    d: "M196.285 78.455v29.666"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0CA933",
    fillRule: "evenodd",
    d: "M185.534 107.079v1.08h9.582c1.892 0 3.679 2.035 5.032 4.783.269.547.515 1.132.736 1.748h.937a19.54 19.54 0 0 0-1.133-2.89c-1.498-3.045-3.476-4.721-5.572-4.721h-9.582Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D4A55",
    fillRule: "evenodd",
    d: "M192.457 114.736h-15.935v-2.875l20.831 1.579 3.231-.564h8.433v1.86H192.457Z",
    clipRule: "evenodd"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#202931",
    fillRule: "evenodd",
    d: "M188.285 125.298a33.94 33.94 0 0 0 .044 1.673h1.769a16.174 16.174 0 0 1-.032-.586 23.943 23.943 0 0 1 .121-3.765c.383-3.455 1.497-6.335 2.985-7.902h-2.869c-.972 2.152-1.651 4.878-1.906 7.902a31.596 31.596 0 0 0-.112 2.678Z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#33CC60",
    fillRule: "evenodd",
    d: "M209.595 114.717c.499 0 .907.405.907.9v11.759a.906.906 0 0 1-.907.901h-11.337a.906.906 0 0 1-.906-.901v-11.759c0-.495.408-.9.906-.9h11.337Z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4A55",
    fillRule: "evenodd",
    d: "M203.407 123.431c-.269-3.182-.857-6.572-1.88-8.838h-11.866c-1.322 8.406-3.208 11.939-3.208 11.939s2.917 1.677 2.912 1.739h14.113c.009-.151.015-.562.022-.715.016-.431.024-.869.024-1.306 0-.962-.039-1.904-.117-2.819Z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#33CC60",
    fillRule: "evenodd",
    d: "M183.89 68.122h21.126c2.674 0 2.561 3.855 3.167 10.247h-22.649v-7.322c0-2.97-1.644-2.925-1.644-2.925Z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E768A",
    fillRule: "evenodd",
    d: "M190.553 109.802c-3.679-.185-6.809 5.206-7.508 12.448a32.018 32.018 0 0 0-.142 2.67c-.007.564.002 1.822.024 2.373h5.599l5.977-7.134V109.82l-3.95-.018Z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#202931",
    fillRule: "evenodd",
    d: "M198.665 116.085c-1.117-1.724-2.508-3.754-4.006-3.678-1.498.075-3.776 2.245-4.853 4.079-.222.379-.428.797-.624 1.233l-1.565-2.712c-3.155.159-5.652 5.597-5.575 12.143.076 6.549 2.697 11.728 5.852 11.569h5.723l-.663-14.466-2.619-4.537c.875-1.88 2.092-3.079 3.448-3.148 2.736-.137 5.016 4.367 5.082 10.043.007.57-.009 1.13-.047 1.676l2.433-.077c.027-.547.038-1.107.031-1.675-.05-4.292-1.071-8.068-2.617-10.45Z",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4A55",
    fillRule: "evenodd",
    d: "M194.069 115.007c-3.155.159-5.652 5.597-5.575 12.144.077 6.548 2.697 11.727 5.852 11.568 3.156-.159 5.652-5.596 5.575-12.145-.076-6.546-2.697-11.726-5.852-11.567Z",
    clipRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFF",
    fillRule: "evenodd",
    d: "M194.117 119.118c-2.059.104-3.692 3.662-3.642 7.933.05 4.271 1.765 7.661 3.823 7.558 2.058-.105 3.692-3.664 3.643-7.935-.05-4.27-1.766-7.66-3.824-7.556Z",
    clipRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1CED9",
    fillRule: "evenodd",
    d: "M197.432 126.709c.007.652-.031 1.281-.112 1.877-.27 2.016-1.002 3.641-1.952 4.336a1.78 1.78 0 0 1-.957.365 1.666 1.666 0 0 1-.963-.268c-.951-.589-1.714-2.103-2.039-4.052a12.77 12.77 0 0 1-.168-1.946c-.008-.682.035-1.339.123-1.961.28-1.995 1.015-3.594 1.962-4.269.293-.212.608-.334.935-.351.328-.017.644.074.942.256.975.586 1.753 2.144 2.073 4.145.094.588.148 1.215.156 1.868Z",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E768A",
    fillRule: "evenodd",
    d: "m200.949 128.211-.762.038.762-.038ZM201.98 126.485a31.206 31.206 0 0 0-.142-2.671c-.649-6.727-3.397-11.854-6.733-12.401l.074-.051-6.33.003c-2.457.123-4.75 2.713-6.155 6.603-.697 1.926-1.176 4.168-1.351 6.588a31.078 31.078 0 0 0-.08 2.681c0 .134.004.264.007.399.011.428.03.856.055 1.273l5.78-.046.002.045 1.009-.05a27.55 27.55 0 0 1-.07-1.67c-.05-4.293.882-8.168 2.369-10.702 1.076-1.835 2.442-2.963 3.94-3.038 1.498-.076 2.888.913 4.006 2.637 1.546 2.382 2.567 6.158 2.617 10.451.007.566-.004 1.126-.031 1.674l1.009-.05c.023-.55.032-1.111.024-1.675Z",
    clipRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E768A",
    fillRule: "evenodd",
    d: "M195.179 111.361s-4.553-.295-6.243 4.635l-6.242 1.972c1.406-3.89 3.698-6.479 6.155-6.603l6.33-.004Z",
    clipRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFF",
    fillRule: "evenodd",
    d: "M195.179 126.821a3.54 3.54 0 0 1-.031.512c-.073.547-.272.99-.531 1.179a.484.484 0 0 1-.26.1.46.46 0 0 1-.263-.073c-.258-.16-.466-.573-.554-1.103a3.554 3.554 0 0 1-.013-1.064c.076-.542.277-.978.534-1.162a.485.485 0 0 1 .255-.095.45.45 0 0 1 .256.07c.266.16.478.583.564 1.128.026.16.041.331.043.508Z",
    clipRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#202931",
    fillRule: "evenodd",
    d: "M161.648 116.085c-1.117-1.724-2.508-3.754-4.006-3.678-1.498.075-3.777 2.245-4.852 4.079-.223.379-.428.797-.625 1.233l-1.566-2.712c-3.155.159-5.65 5.597-5.574 12.143.077 6.549 2.697 11.728 5.852 11.569h5.722l-.662-14.466-2.619-4.537c.875-1.88 2.092-3.079 3.448-3.148 2.736-.137 5.016 4.367 5.082 10.043.007.57-.009 1.13-.047 1.676l2.433-.077c.027-.547.038-1.107.031-1.675-.05-4.292-1.071-8.068-2.617-10.45Z",
    clipRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4A55",
    fillRule: "evenodd",
    d: "M157.052 115.007c-3.155.159-5.651 5.597-5.575 12.144.077 6.548 2.697 11.727 5.852 11.568 3.156-.159 5.652-5.596 5.576-12.145-.077-6.546-2.698-11.726-5.853-11.567Z",
    clipRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFF",
    fillRule: "evenodd",
    d: "M157.1 119.118c-2.058.104-3.692 3.662-3.642 7.933.05 4.271 1.765 7.661 3.823 7.558 2.059-.105 3.692-3.664 3.643-7.935-.051-4.27-1.766-7.66-3.824-7.556Z",
    clipRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1CED9",
    fillRule: "evenodd",
    d: "M160.415 126.709c.008.652-.032 1.281-.112 1.877-.27 2.016-1.002 3.641-1.952 4.336a1.78 1.78 0 0 1-.957.365 1.666 1.666 0 0 1-.963-.268c-.951-.589-1.714-2.103-2.039-4.052a12.77 12.77 0 0 1-.168-1.946c-.008-.682.035-1.339.122-1.961.281-1.995 1.016-3.594 1.963-4.269.293-.212.608-.334.935-.351.327-.017.644.074.942.256.975.586 1.753 2.144 2.073 4.145.094.588.148 1.215.156 1.868Z",
    clipRule: "evenodd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E768A",
    fillRule: "evenodd",
    d: "m163.932 128.211-.761.038.761-.038ZM164.963 126.485a31.2 31.2 0 0 0-.143-2.671c-.648-6.727-3.396-11.854-6.732-12.401l.074-.051-6.33.003c-2.458.123-4.75 2.713-6.155 6.603-.698 1.926-1.175 4.168-1.351 6.588a30.681 30.681 0 0 0-.08 2.681c0 .134.004.264.007.399.011.428.029.856.055 1.273l5.78-.046.002.045 1.009-.05a28.388 28.388 0 0 1-.07-1.67c-.05-4.293.881-8.168 2.369-10.702 1.075-1.835 2.442-2.963 3.94-3.038 1.497-.076 2.889.913 4.006 2.637 1.546 2.382 2.566 6.158 2.617 10.451.007.566-.005 1.126-.031 1.674l1.009-.05c.023-.55.031-1.111.024-1.675Z",
    clipRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E768A",
    fillRule: "evenodd",
    d: "M158.162 111.361s-4.553-.295-6.242 4.635l-6.243 1.972c1.406-3.89 3.698-6.479 6.155-6.603l6.33-.004Z",
    clipRule: "evenodd"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFF",
    fillRule: "evenodd",
    d: "M158.162 126.821a3.54 3.54 0 0 1-.031.512c-.074.547-.272.99-.531 1.179a.484.484 0 0 1-.26.1.46.46 0 0 1-.263-.073c-.259-.16-.466-.573-.554-1.103a3.553 3.553 0 0 1-.012-1.064c.076-.542.276-.978.534-1.162a.48.48 0 0 1 .254-.095.45.45 0 0 1 .256.07c.266.16.478.583.565 1.128.025.16.039.331.042.508Z",
    clipRule: "evenodd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4A55",
    fillRule: "evenodd",
    d: "M8.518 118.837H13v-10.06H8.518v10.06ZM70.251 105.67v9.422c0 .38.313.692.696.692h77.612a.696.696 0 0 0 .696-.692v-8.779",
    clipRule: "evenodd"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1CED9",
    fillRule: "evenodd",
    d: "M145.461 126.728c0 .819-.674 1.489-1.499 1.489h-20.247c-.824 0-1.498-.67-1.498-1.489v-12.343c0-.819.674-1.489 1.498-1.489h20.247c.825 0 1.499.67 1.499 1.489v12.343Z",
    clipRule: "evenodd"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E768A",
    fillRule: "evenodd",
    d: "M144.976 126.137c-.266.285-1.158.519-1.982.519h-15.599c-.824 0-1.498-.67-1.498-1.489v-10.769c0-.819-.675-1.489-1.499-1.489h-3.338c-.823 0-1.498.67-1.498 1.489v12.344c0 .819.675 1.489 1.498 1.489h3.338c.824 0 1.499-.003 1.499-.008 0-.004.674-.006 1.498-.006h15.599c.824 0 1.716-.234 1.982-.519.266-.284.484-2.135.484-2.565 0-.429-.218.72-.484 1.004Z",
    clipRule: "evenodd"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E768A",
    fillRule: "evenodd",
    d: "M118.022 122.012c0 .654.539 1.19 1.198 1.19h3.26c.658 0 1.197-.414 1.197-.919v-12.428c0-.655-.539-1.19-1.197-1.19h-3.26c-.659 0-1.198.535-1.198 1.19v12.157Z",
    clipRule: "evenodd"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E768A",
    fillRule: "evenodd",
    d: "M117.865 108.462v7.861c0 .654.539 1.19 1.197 1.19h3.464c.658 0 1.197-.414 1.197-.919v-8.132M77.76 113.332l2.164-7.008-1.68-2.039-1.958 6.329-1.233 3.987-1.277 4.133 1.684 2.035.922-2.982 1.378-4.455ZM57.448 111.871l1.418-4.59 1.726 5.58a14.573 14.573 0 0 0-1.242 2.248c-.542-1.286-1.186-2.38-1.902-3.238Zm-17.552-.497 1.014-3.279 1.628 5.267c-.206.337-.406.693-.595 1.069-.592-1.245-1.283-2.281-2.047-3.057Zm31.694-1.578-.28.001v-.001l-3.497.003-1.703-5.515-1.681 2.041 1.073 3.475h-.521c-.928.047-1.832.449-2.674 1.137l-.09-.294-1.966-6.359-1.385 1.679-1.386-1.679-1.862 6.025a3.98 3.98 0 0 0-1.695-.505l.01-.008-.35.001v-.001l-6.33.004c-1.068.054-2.103.578-3.05 1.468l-.171-.557-1.987-6.427-1.135 1.377-1.136-1.377-1.786 5.78a3.885 3.885 0 0 0-.772-.215l.073-.053-6.33.004c-1.266.064-2.487.786-3.567 2.001l-.46-1.49-1.861-6.027-1.682 2.041 2.04 6.597.375 1.215a17.54 17.54 0 0 0-1 2.266l.155-.04c-.052.134-.105.265-.154.403-.698 1.926-1.176 4.168-1.352 6.588a30.695 30.695 0 0 0-.073 3.08c.012.428.03.857.055 1.274l.838-.007c.547 5.511 2.925 9.595 5.732 9.454h5.722l-.003-.072c.24.052.484.085.733.072 2.407-.121 4.427-3.32 5.217-7.737.825 4.619 2.988 7.863 5.494 7.737h5.66l-.018-.075c.246.054.495.088.75.075 2.368-.12 4.366-3.214 5.182-7.522.853 4.503 2.986 7.646 5.453 7.522h5.997s-3.958-17.501-4.626-20.588c.245-.593.513-1.148.804-1.645.185-.313.327-.605.446-.875l.773 2.5 1.304 4.221 1.682-2.034-1.541-4.983-.572-1.85c.057-.007.112-.015.175-.018l2.953-2.087ZM85.07 110.711l-1.986-6.427-1.135 1.377-1.136-1.377-2.063 6.676-1.246 4.036-1.155 3.738 1.681 2.034.744-2.405 1.413-4.568 1.763-5.699 1.659 5.368 1.142 3.689 1.116 3.615 1.684-2.034-1.413-4.572-1.067-3.451Z",
    clipRule: "evenodd"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E768A",
    fillRule: "evenodd",
    d: "m119.282 104.285-1.957 6.329-1.233 3.987-1.277 4.132 1.684 2.036.922-2.982 1.378-4.455 2.164-7.008-1.681-2.039ZM103.256 110.643l-1.966-6.358-1.385 1.678-1.386-1.678-1.935 6.261-1.23 3.982-1.302 4.206 1.684 2.034.954-3.088 1.374-4.436 1.841-5.963 1.884 6.09 1.138 3.684 1.147 3.713 1.684-2.034-1.435-4.641-1.067-3.45ZM65.504 109.501c-.543.796-1.335 2.05-1.768 3.065l1.438 4.489c.385-1.122 1.158-2.46 1.698-3.299l-1.368-4.255Z",
    clipRule: "evenodd"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4A55",
    fillRule: "evenodd",
    d: "M3.02 106.127v4.974c0 .381.314.692.696.692h102.681a.697.697 0 0 0 .697-.692v-5.151",
    clipRule: "evenodd"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E768A",
    fillRule: "evenodd",
    d: "M106.543 109.501c-.542.796-1.334 2.05-1.768 3.065l1.438 4.489c.385-1.122 1.157-2.46 1.698-3.299l-1.368-4.255Z",
    clipRule: "evenodd"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#202931",
    fillRule: "evenodd",
    d: "M114.954 114.521c-1.117-1.724-2.508-3.754-4.006-3.679-1.498.076-3.777 2.245-4.853 4.079-.223.379-.428.797-.625 1.234l-1.565-2.712c-3.155.159-5.651 5.597-5.574 12.143.076 6.549 2.697 11.728 5.852 11.569h5.722l-.662-14.466-2.619-4.537c.875-1.881 2.092-3.079 3.448-3.148 2.736-.138 5.016 4.367 5.082 10.042.006.57-.009 1.131-.047 1.677l2.433-.077c.027-.548.038-1.108.031-1.676-.05-4.291-1.072-8.068-2.617-10.449Z",
    clipRule: "evenodd"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4A55",
    fillRule: "evenodd",
    d: "M110.358 113.443c-3.155.159-5.651 5.597-5.576 12.144.077 6.548 2.698 11.727 5.853 11.568 3.155-.159 5.652-5.596 5.575-12.145-.076-6.547-2.697-11.726-5.852-11.567Z",
    clipRule: "evenodd"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFF",
    fillRule: "evenodd",
    d: "M110.406 117.554c-2.059.104-3.692 3.662-3.642 7.932.05 4.271 1.765 7.662 3.823 7.558 2.058-.104 3.692-3.663 3.642-7.934-.05-4.27-1.765-7.66-3.823-7.556Z",
    clipRule: "evenodd"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1CED9",
    fillRule: "evenodd",
    d: "M113.721 125.144c.007.652-.031 1.282-.112 1.878-.27 2.015-1.002 3.641-1.951 4.336-.3.219-.622.347-.958.364a1.651 1.651 0 0 1-.963-.268c-.951-.588-1.714-2.103-2.039-4.052a12.899 12.899 0 0 1-.168-1.946c-.008-.681.035-1.339.123-1.96.28-1.996 1.015-3.594 1.962-4.27.293-.211.608-.334.936-.35.327-.017.643.074.941.256.975.586 1.753 2.143 2.073 4.145.094.588.148 1.215.156 1.867Z",
    clipRule: "evenodd"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E768A",
    fillRule: "evenodd",
    d: "m117.238 126.646-.761.038.761-.038ZM118.269 124.921a31.179 31.179 0 0 0-.143-2.671c-.648-6.728-3.396-11.855-6.732-12.401l.074-.052-6.33.003c-2.457.124-4.75 2.714-6.155 6.603-.697 1.927-1.176 4.168-1.35 6.589a30.72 30.72 0 0 0-.081 2.681c0 .134.004.264.007.399.01.428.03.856.055 1.273l5.78-.046.002.045 1.009-.051a26.695 26.695 0 0 1-.07-1.67c-.05-4.292.881-8.167 2.369-10.702 1.076-1.834 2.442-2.962 3.94-3.038 1.498-.075 2.888.914 4.006 2.638 1.545 2.381 2.566 6.158 2.617 10.45.007.567-.004 1.127-.031 1.675l1.009-.051c.022-.55.031-1.11.024-1.674Z",
    clipRule: "evenodd"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E768A",
    fillRule: "evenodd",
    d: "M111.468 109.797s-4.553-.296-6.243 4.635l-6.242 1.971c1.405-3.889 3.698-6.479 6.155-6.603l6.33-.003Z",
    clipRule: "evenodd"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFF",
    fillRule: "evenodd",
    d: "M111.468 125.257c.001.177-.009.349-.031.511-.074.548-.272.991-.531 1.18a.475.475 0 0 1-.261.099.443.443 0 0 1-.262-.073c-.259-.16-.466-.572-.554-1.102a3.437 3.437 0 0 1-.013-1.064c.076-.543.276-.978.534-1.162a.477.477 0 0 1 .254-.095c.09-.004.176.02.257.069.265.161.478.584.564 1.128.026.161.041.331.043.509Z",
    clipRule: "evenodd"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#202931",
    fillRule: "evenodd",
    d: "M97.887 114.521c-1.118-1.724-2.509-3.754-4.007-3.679-1.497.076-3.776 2.245-4.852 4.079-.223.379-.428.797-.625 1.234l-1.565-2.712c-3.155.159-5.651 5.597-5.575 12.143.077 6.549 2.697 11.728 5.853 11.569h5.722l-.662-14.466-2.62-4.537c.876-1.881 2.092-3.079 3.448-3.148 2.736-.138 5.016 4.367 5.082 10.042.007.57-.009 1.131-.046 1.677l2.433-.077c.026-.548.037-1.108.031-1.676-.051-4.291-1.072-8.068-2.617-10.449Z",
    clipRule: "evenodd"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4A55",
    fillRule: "evenodd",
    d: "M93.29 113.443c-3.155.159-5.65 5.597-5.575 12.144.077 6.548 2.698 11.727 5.853 11.568 3.155-.159 5.652-5.596 5.575-12.145-.077-6.547-2.697-11.726-5.853-11.567Z",
    clipRule: "evenodd"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFF",
    fillRule: "evenodd",
    d: "M93.338 117.554c-2.058.104-3.692 3.662-3.642 7.932.05 4.271 1.765 7.662 3.824 7.558 2.058-.104 3.691-3.663 3.642-7.934-.05-4.27-1.766-7.66-3.824-7.556Z",
    clipRule: "evenodd"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1CED9",
    fillRule: "evenodd",
    d: "M96.653 125.144c.008.652-.03 1.282-.112 1.878-.27 2.015-1.001 3.641-1.951 4.336-.3.219-.622.347-.957.364a1.652 1.652 0 0 1-.964-.268c-.95-.588-1.714-2.103-2.038-4.052a12.808 12.808 0 0 1-.169-1.946c-.008-.681.035-1.339.123-1.96.28-1.996 1.016-3.594 1.963-4.27.293-.211.608-.334.935-.35.327-.017.643.074.941.256.975.586 1.753 2.143 2.073 4.145.094.588.148 1.215.156 1.867Z",
    clipRule: "evenodd"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E768A",
    fillRule: "evenodd",
    d: "m100.17 126.646-.76.038.76-.038ZM101.202 124.921a31.59 31.59 0 0 0-.143-2.671c-.648-6.728-3.397-11.855-6.733-12.401l.075-.052-6.33.003c-2.458.124-4.75 2.714-6.155 6.603-.698 1.927-1.176 4.168-1.351 6.589a30.68 30.68 0 0 0-.08 2.681 34.559 34.559 0 0 0 .062 1.672l5.78-.046c0 .014 0 .03.002.045l1.008-.051a27.403 27.403 0 0 1-.07-1.67c-.05-4.292.882-8.167 2.37-10.702 1.075-1.834 2.442-2.962 3.94-3.038 1.497-.075 2.888.914 4.006 2.638 1.545 2.381 2.566 6.158 2.617 10.45.006.567-.005 1.127-.031 1.675l1.009-.051c.022-.55.031-1.11.024-1.674Z",
    clipRule: "evenodd"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E768A",
    fillRule: "evenodd",
    d: "M94.4 109.797s-4.553-.296-6.242 4.635l-6.242 1.971c1.405-3.889 3.698-6.479 6.155-6.603l6.33-.003Z",
    clipRule: "evenodd"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFF",
    fillRule: "evenodd",
    d: "M94.4 125.257c.002.177-.009.349-.03.511-.074.548-.273.991-.532 1.18a.473.473 0 0 1-.26.099.443.443 0 0 1-.262-.073c-.259-.16-.467-.572-.555-1.102a3.464 3.464 0 0 1-.012-1.064c.076-.543.276-.978.534-1.162a.475.475 0 0 1 .254-.095c.09-.004.175.02.256.069.266.161.478.584.565 1.128.025.161.04.331.042.509Z",
    clipRule: "evenodd"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#202931",
    fillRule: "evenodd",
    d: "M80.82 114.521c-1.118-1.724-2.509-3.754-4.007-3.679-1.497.076-3.776 2.245-4.852 4.079-.223.379-.429.797-.625 1.234l-1.565-2.712c-3.155.159-5.652 5.597-5.575 12.143.077 6.549 2.697 11.728 5.853 11.569h5.722l-.663-14.466-2.618-4.537c.875-1.881 2.091-3.079 3.447-3.148 2.736-.138 5.016 4.367 5.082 10.042.007.57-.009 1.131-.046 1.677l2.433-.077c.026-.548.037-1.108.03-1.676-.05-4.291-1.071-8.068-2.616-10.449Z",
    clipRule: "evenodd"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4A55",
    fillRule: "evenodd",
    d: "M76.223 113.443c-3.155.159-5.65 5.597-5.575 12.144.077 6.548 2.697 11.727 5.853 11.568 3.155-.159 5.651-5.596 5.574-12.145-.076-6.547-2.697-11.726-5.852-11.567Z",
    clipRule: "evenodd"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFF",
    fillRule: "evenodd",
    d: "M76.271 117.554c-2.058.104-3.692 3.662-3.642 7.932.05 4.271 1.765 7.662 3.824 7.558 2.058-.104 3.692-3.663 3.642-7.934-.05-4.27-1.766-7.66-3.824-7.556Z",
    clipRule: "evenodd"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1CED9",
    fillRule: "evenodd",
    d: "M79.586 125.144c.008.652-.031 1.282-.112 1.878-.27 2.015-1.001 3.641-1.951 4.336-.3.219-.622.347-.957.364a1.651 1.651 0 0 1-.964-.268c-.95-.588-1.714-2.103-2.039-4.052a12.795 12.795 0 0 1-.168-1.946 12.99 12.99 0 0 1 .123-1.96c.28-1.996 1.015-3.594 1.963-4.27.293-.211.608-.334.935-.35.327-.017.643.074.941.256.975.586 1.753 2.143 2.073 4.145.094.588.148 1.215.156 1.867Z",
    clipRule: "evenodd"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E768A",
    fillRule: "evenodd",
    d: "m83.103 126.646-.761.038.761-.038ZM84.134 124.921a31.345 31.345 0 0 0-.142-2.671c-.649-6.728-3.397-11.855-6.733-12.401l.074-.052-6.33.003c-2.457.124-4.75 2.714-6.154 6.603-.698 1.927-1.177 4.168-1.352 6.589a30.719 30.719 0 0 0-.08 2.681c0 .134.004.264.007.399.011.428.03.856.055 1.273l5.78-.046.002.045 1.009-.051a27.324 27.324 0 0 1-.07-1.67c-.05-4.292.882-8.167 2.369-10.702 1.076-1.834 2.442-2.962 3.94-3.038 1.498-.075 2.888.914 4.007 2.638 1.545 2.381 2.566 6.158 2.616 10.45.007.567-.004 1.127-.03 1.675l1.008-.051c.023-.55.032-1.11.024-1.674Z",
    clipRule: "evenodd"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E768A",
    fillRule: "evenodd",
    d: "M77.333 109.797s-4.553-.296-6.242 4.635l-6.242 1.971c1.405-3.889 3.697-6.479 6.155-6.603l6.33-.003Z",
    clipRule: "evenodd"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFF",
    fillRule: "evenodd",
    d: "M77.333 125.257c.002.177-.009.349-.03.511-.074.548-.273.991-.532 1.18a.473.473 0 0 1-.26.099.444.444 0 0 1-.262-.073c-.26-.16-.467-.572-.555-1.102a3.562 3.562 0 0 1-.012-1.064c.075-.543.276-.978.534-1.162a.475.475 0 0 1 .254-.095.451.451 0 0 1 .256.069c.266.161.478.584.565 1.128.025.161.04.331.042.509Z",
    clipRule: "evenodd"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4A55",
    fillRule: "evenodd",
    d: "M45.754 118.474h4.482v-10.059h-4.482v10.059Z",
    clipRule: "evenodd"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFF",
    fillRule: "evenodd",
    d: "M5.546 106.99c-1.393 0-2.532-.934-2.532-2.075v-54.84c0-1.14 1.14-2.075 2.532-2.075h152.635c1.392 0 18.871.934 18.871 2.075v54.84c0 1.141-6.016 2.075-7.408 2.075H5.546Z",
    clipRule: "evenodd"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFF",
    fillRule: "evenodd",
    d: "M5.373 103.187h48.163V51.418H5.373v51.769Z",
    clipRule: "evenodd"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5E768A",
    d: "M5.373 103.187h48.163V51.418H5.373v51.769Z",
    clipRule: "evenodd"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1CED9",
    fillRule: "evenodd",
    d: "M57.875 107.188c-1.149 0-2.088-.914-2.088-2.03V51.526c0-1.116.94-2.029 2.088-2.029h118.167c1.148 0 2.088.913 2.088 2.029v53.632c0 1.116-.94 2.03-2.088 2.03H57.875Z",
    clipRule: "evenodd"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E768A",
    fillRule: "evenodd",
    d: "M2.958 108.581h53.03v-2.923H2.958v2.923Z",
    clipRule: "evenodd"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E768A",
    fillRule: "evenodd",
    d: "M55.092 108.583h124.555v-2.923H55.092v2.923Z",
    clipRule: "evenodd"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1CED9",
    fillRule: "evenodd",
    d: "M2.249 122.647H56.14v-5.673H2.249v5.673Z",
    clipRule: "evenodd"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFF",
    fillRule: "evenodd",
    d: "M2.249 125.456H56.14v-5.673H2.249v5.673Z",
    clipRule: "evenodd"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1CED9",
    fillRule: "evenodd",
    d: "M54.448 116.974V125.456h3.22v-8.482h-3.22Z",
    clipRule: "evenodd"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#33CC60",
    fillRule: "evenodd",
    d: "M9.438 121.751a.73.73 0 0 0-.73-.726H4.65a.73.73 0 0 0-.73.726v1.737c0 .4.329.726.73.726h4.056a.73.73 0 0 0 .73-.726v-1.737Z",
    clipRule: "evenodd"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFF",
    fillRule: "evenodd",
    d: "M33.9 121.388a.366.366 0 0 0-.365-.363h-11.6a.366.366 0 0 0-.366.363v2.1c0 .2.164.363.365.363h11.6c.201 0 .366-.163.366-.363v-2.1Z",
    clipRule: "evenodd"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#33CC60",
    fillRule: "evenodd",
    d: "M52.514 121.751a.73.73 0 0 0-.73-.726H47.73a.73.73 0 0 0-.73.726v1.737c0 .4.328.726.73.726h4.055a.73.73 0 0 0 .73-.726v-1.737Z",
    clipRule: "evenodd"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0CA933",
    strokeWidth: 1.391,
    d: "M208.213 78.455h-22.634"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E768A",
    fillRule: "evenodd",
    d: "M183.898 125.013h-9.758v-12.295h-4.927v13.87h4.927v-.014h9.909c.779 0 .84-.777.84-2.303v-1.561c0 1.268-.446 2.303-.991 2.303Z",
    clipRule: "evenodd"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1CED9",
    fillRule: "evenodd",
    d: "M184.889 123.553c0 .819-.674 1.489-1.498 1.489H173c-.824 0-1.498-.67-1.498-1.489v-9.359c0-.82.674-1.49 1.498-1.49h10.391c.824 0 1.498.67 1.498 1.49v9.359Z",
    clipRule: "evenodd"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E768A",
    fillRule: "evenodd",
    d: "M168.266 122.458c.085.648.693 1.18 1.352 1.18h1.538c.659 0 1.197-.414 1.197-.919v-7.174c0-.654-.538-1.189-1.197-1.189H168.4c-.659 0-1.128.531-1.043 1.18l.909 6.922Z",
    clipRule: "evenodd"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5E768A",
    d: "M28.452 51.418v51.769"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E768A",
    fillRule: "evenodd",
    d: "M24.501 80.143h1.897v-4.902H24.5v4.902ZM30.718 80.143h1.897v-4.902h-1.897v4.902Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationTruckFacility);
export default __webpack_public_path__ + "static/media/illustration-truck-facility.b857625d8c1acc026567a296b244dd3e.svg";
export { ForwardRef as ReactComponent };